import { render, staticRenderFns } from "./PanoramasNav.vue?vue&type=template&id=173a337f&scoped=true&"
import script from "./PanoramasNav.vue?vue&type=script&lang=js&"
export * from "./PanoramasNav.vue?vue&type=script&lang=js&"
import style0 from "./PanoramasNav.vue?vue&type=style&index=0&id=173a337f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173a337f",
  null
  
)

export default component.exports